<template>
  <div>
    <baseModal
      width="860px"
      :title="titleName"
      @sureFun="handleSubmit"
      @cancalFun="handleCancel"
      :dialogVisible="visibleDialog"
    >
      <template #content="scope">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in shopList"
            :key="index"
            :label="item.title"
            :name="item.key"
          ></el-tab-pane>
        </el-tabs>
        <!-- 店铺/营销/应用 -->
        <div class="content">
          <div
            class="shop_box"
            v-if="
              activeName == 'shop' ||
              activeName == 'app' ||
              activeName == 'marketing'
            "
          >
            <div
              class="shop_item"
              v-for="(item, index) in shopList[tabsValue].data"
              :key="index"
            >
              <div class="tit_box">{{ item.title }}</div>
              <div class="box">
                <div
                  class="item"
                  :class="gtem.id == gndexValue ? 'item_active' : ''"
                  @click="handleClickItem(gtem)"
                  v-for="(gtem, gndex) in item.data"
                  :key="gndex"
                >
                  {{ gtem.title }}
                </div>
              </div>
            </div>
          </div>
          <!-- 自定义页面 -->
          <baseTable
            rowKey="page_id"
            :loading="search.loading"
            :total="search.total"
            :page="search.post.page"
            :pagesize="search.post.limit"
            :list="search.table"
            :tableList="search.tableForm"
            :multiply="false"
            @changePage="changePage"
            @tableSelectionChange="tableSelectionChangeself"
            v-if="activeName == 'self'"
          >
            <!-- 页面类型 -->
            <template #page_type="scope">
			  <span v-if="scope?.row?.page_type == '10'"
			  	style="font-size:12px;background: #006aff1A;color: #006aff; border-radius: 2px; height: 24px; width: 68px; display: inline-block">商城首页</span>
			  <span v-else-if="scope?.row?.page_type == '30'"
			  	style="font-size:12px;background: #19be6b1A;color: #19be6b; border-radius: 2px; height: 24px; width: 68px; display: inline-block">个人中心</span>
			  <span v-else-if="scope?.row?.page_type == '40'"
			  	style="font-size:12px;background: #04af021A;color: #04af02; border-radius: 2px; height: 24px; width: 68px; display: inline-block">商品详情</span>
			  <span v-else
			  	style="font-size:12px;background: #FF88001A;color: #FF8800; border-radius: 2px; height: 24px; width: 68px; display: inline-block">自定义页面</span>
            </template>
            <!-- 访问权限 -->
            <template #is_open="scope">
              {{ scope.row.is_open == 1 ? "加密" : "公开" }}
            </template>
          </baseTable>
          <!-- 商品分类 -->
          <categoryTable
            @getItem="getItem"
            v-if="activeName == 'cate'"
          ></categoryTable>
		  <!-- 门店分类 -->
		  <categoryTablestore
		    @getItem="getItemStore"
		    v-if="activeName == 'store'"
		  ></categoryTablestore>
          <!-- 商品 -->
		  <div v-if="activeName == 'commidy'" class="shang">
			  <div class="shang_head">
				  <el-form :inline="true" class="demo-form-inline">
				    <el-form-item label="商品名称">
				      <el-input v-model="searchCom.post.goodsName" size="small" placeholder="请输入商品名称"></el-input>
				    </el-form-item>
				    <el-form-item>
				      <el-button @click="getGoodsList()" type="primary" class="base_but_style" >查询</el-button>
				    </el-form-item>
				  </el-form>
			  </div>
			  <div class="shang_tab">
				  <div @click="searchCom.post.listType='all';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='all'?'shang_tab_active':'']" class="shang_tab_item">全部</div>
				  <div @click="searchCom.post.listType='on_sale';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='on_sale'?'shang_tab_active':'']" class="shang_tab_item">出售中</div>
				  <div @click="searchCom.post.listType='off_sale';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='off_sale'?'shang_tab_active':'']" class="shang_tab_item">已下架</div>
				  <div @click="searchCom.post.listType='sold_out';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='sold_out'?'shang_tab_active':'']" class="shang_tab_item">已售罄</div>
			  </div>
			  <div class="shang_box">
				  <div v-if="searchCom.table.length<=0" style="width: 100%;padding: 40px 0;color: #999;text-align: center;">暂无数据</div>
				  <div @click="selectGood(index)" :class="[item.select?'shang_box_active':'']" v-for="(item,index) in searchCom.table" :key="index" class="shang_box_item">
					  <i v-if="item.select" class="shang_box_radio el-icon-success"></i>
					  <img class="shang_box_img" :src="item.goods_image" alt="" />
						<div class="shang_box_flex ">
							<div class="shang_box_title ">{{item.goods_name || ''}}</div>
							<div class="shang_box_data">
								<div class="shang_box_price">{{item.goods_price_min || ''}}</div>
								<div class="shang_box_num">库存:{{item.stock_total || ''}}</div>
							</div>
						</div>
				  </div>
			  </div>
			  <div v-if="searchCom.table.length>0" style="text-align: center;">
				  <el-pagination
				    background @current-change="changepageGood"
				  				:page-size="12"
				    layout="prev, pager, next" :total="searchCom.total">
				  </el-pagination>
				  
			  </div>
		  </div>
		  <categoryTablevote
		    @getItem="getItemVote"
		    v-if="activeName == 'vote'"
		  ></categoryTablevote>
		  <categoryTablegroup
		    @getItem="getItemGroup"
		    v-if="activeName == 'group'"
		  ></categoryTablegroup>
			<categoryTablesign
			  @getItem="getItemSign"
			  v-if="activeName == 'sign'"
			></categoryTablesign>
          <!-- <baseTable
            :multiply="false"
            :loading="searchCom.loading"
            :total="searchCom.total"
            :page="searchCom.post.page"
            :pagesize="searchCom.post.limit"
            :list="searchCom.table"
            :tableList="searchCom.tableForm"
            @changePage="changePageCom"
            @tableSelectionChange="tableSelectionChange"
            v-if="activeName == 'commidy'"
          >
            <template #goods_info="scope">
              <div class="goods_item">
                <img :src="scope.row.goods_image" width="60px" alt="" />
                <div class="goods_item_box">
                  <div class="name">{{ scope.row.goods_name }}</div>
                </div>
              </div>
            </template>
            <template #status="scope">
              <el-tag :type="scope.row.status == '10' ? 'success' : ''">{{
                scope.row.status == "10" ? "上架" : "下架"
              }}</el-tag>
            </template>
          </baseTable> -->
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
            v-if="activeName == 'other'"
          >
            <el-form-item label="其他页面" prop="id">
              <el-select
                v-model="ruleForm.id"
                style="width: 350px"
                placeholder="请选择其他页面"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 自定义路径 -->
            <blockquote v-if="ruleForm.id == '1'">
              <el-form-item label="页面路径" prop="path">
                <el-input
                  v-model="ruleForm.path"
                  @blur="validatePath"
                  placeholder="pages/xx"
                  style="width: 350px"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面参数" prop="queryStr">
                <el-input
                  v-model="ruleForm.queryStr"
                  style="width: 350px"
                ></el-input>
              </el-form-item>
            </blockquote>
            <!-- 跳转微信小程序 -->
            <blockquote v-if="ruleForm.id == '2'">
              <el-form-item label="AppID" prop="AppID">
                <el-input
                  v-model="ruleForm.AppID"
                  style="width: 350px"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面路径" prop="wpath">
                <el-input
                  style="width: 350px"
                  v-model="ruleForm.wpath"
                  placeholder="填写要跳转的微信小程序路径"
                ></el-input>
              </el-form-item>
            </blockquote>
            <!-- H5外部链接 -->
            <blockquote v-if="ruleForm.id == '3'">
              <el-form-item label="url" prop="url">
                <el-input
                  style="width: 350px"
                  v-model="ruleForm.url"
                  @blur="validateWpath"
                  placeholder="请输入以https://开头的链接"
                ></el-input>
              </el-form-item>
            </blockquote>
          </el-form>
        </div>
      </template>
    </baseModal>
  </div>
</template>
<script>
import { eltips } from "@/util/util.js";
import { shopList } from "./Links.js";
import baseModal from "@/components/common/baseModal.vue";
import baseTable from "@/components/common/baseTable.vue";
import categoryTable from "./components/categoryTable.vue";
import categoryTablestore from "./components/categoryTablestore.vue";
import categoryTablevote from "./components/categoryTablevote.vue";
import categoryTablegroup from "./components/categoryTablegroup.vue";
import categoryTablesign from "./components/categoryTablesign.vue";
import { isRegionScope, resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";
import { appendCurrentRegionStore } from "@/views/apps/weishop/region/mixins/regionPageAdapter";

export default {
  name: "LinkModal",
  model: {
    prop: "value",
    event: "change",
  },
  components: {
    baseModal,
    baseTable,
    categoryTable,categoryTablestore,categoryTablevote,categoryTablesign,categoryTablegroup
  },
  data() {
    return {
      // 商品
      searchCom: {
        post: {
          page: 1,
          limit: 12,
          goodsName: "",
          categoryId: "",
		  listType:'on_sale'
        },
        loading: false,
        total: 0,
        tableForm: [
          { label: "ID", prop: "goods_id", width: 70 },
          { label: "商品信息", prop: "goods_info", width: 310 },
          { label: "商品价格", prop: "goods_price_min", width: 120 },
          { label: "库存总量", prop: "stock_total" },
          { label: "状态", prop: "status", width: 110 },
        ],
        table: [],
      },
      // 对话框标题
      titleName: "选择链接",
      // 滑块高亮值
      activeName: "shop",
      // modal(对话框)是否可见
      visibleDialog: false,
      // 所有链接数据
      shopList: shopList,
      search: {
        post: {
          page: 1,
          limit: 10,
		  page_type:20
        },
        loading: false,
        total: 0,
        tableForm: [
          { label: "页面ID", prop: "page_id" },
          { label: "页面名称", prop: "page_name" },
          { label: "页面类型", prop: "page_type" },
          { label: "添加时间", prop: "created_at" },
          { label: "访问权限", prop: "is_open" },
        ],
        table: null,
      },
      options: [
        {
          label: "自定义路径",
          value: "1",
        },
        {
          label: "跳转微信小程序",
          value: "2",
        },
        {
          label: "H5外部链接",
          value: "3",
        },
      ],
      tabsValue: 0,
      rules: {
        id: [{ required: true, message: "请选择", trigger: "change" }],
        path: [
          {
            required: true,
            message: "请输入以pages开头的路径",
            trigger: "blur",
          },
        ],
        queryStr: [
          { required: true, message: "请输入页面参数", trigger: "blur" },
        ],
        AppID: [
          {
            required: true,
            message: "填写要跳转的微信小程序AppID",
            trigger: "blur",
          },
        ],
        wpath: [
          {
            required: true,
            message: "填写要跳转的微信小程序路径",
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入以https://开头的链接",
            trigger: "blur",
          },
        ],
      },
      ruleForm: {
        id: "1",
        // 页面路径
        path: "",
        // 页面参数
        queryStr: "",
        // 跳转微信小程序
        AppID: "",
        // 跳转的微信小程序路径
        wpath: "",
        // 请输入以https://开头的链接
        url: "",
      },
      curItem: {},
      gndexValue: "",
    };
  },
  created() {
    // 获取自定义页面列表
    this.getSelfList();
    // 获取商品数据
    this.getGoodsList();
  },
  methods: {
	  changepageGood(e){
		console.log(e)  
		this.searchCom.post.page = e
		this.getGoodsList()
	  },
	  selectGood(index){
		  this.searchCom.table.map(res=>{
			  res.select= false
			  return res
		  })
		this.searchCom.table[index]['select'] = true
		this.curItem = {
		        id: "commidy",
		        path: this.searchCom.table[index].goods_id,
		        title: "商品详情-" + this.searchCom.table[index].goods_name,
		      };
	  },
    // 选中店铺数据
    handleClickItem(item) {
      this.gndexValue = item.id;
      this.curItem = {
        id: item.id,
        path: item.param.path,
        title: item.title,
      };
    },
    // 我是获取到的分类
    getItem(e) {
      this.curItem = {
        id: "cate",
        path: e.category_id,
        title: "商品分类-" + e.name,
      };
    },
	getItemStore(e) {
	  this.curItem = {
	    id: "life",
	    path: e.store_category_id,
	    title: "门店分类-" + e.store_category_name,
	  };
	},
	getItemVote(e) {
	  this.curItem = {
	    id: "vote",
	    path: e.id,
	    title: "投票-" + e.name,
	  };
	},
	getItemGroup(e) {
	  this.curItem = {
	    id: "group",
	    path: e.id,
	    title: "团单-" + e.name,
	  };
	},
	
	getItemSign(e) {
	  this.curItem = {
	    id: "sign",
	    path:'pages/subapp/sign/index?id=' +e.id,
	    title: "签到-" + e.name,
	  };
	},
    handle() {
      this.visibleDialog = true;
    },
    validatePath() {
      // 使用正则表达式校验path是否以'/pages'开头
      console.log("我进入了校验");
      const pathRegex = /^pages/;
      if (!pathRegex.test(this.ruleForm.path)) {
        eltips("请输入以pages开头的路径", "error");
        this.ruleForm.path = "";
      }
    },
    validateWpath() {
      // 使用正则表达式校验wpath是否以'https://'开头
      const wpathRegex = /^https:\/\//;
      if (!wpathRegex.test(this.ruleForm.url)) {
        eltips("请输入以https://开头的链接", "error");
        this.ruleForm.url = "";
      }
    },
    handleClick(tab, event) {
      if (this.activeName == "shop") {
        this.tabsValue = 0;
      } else if (this.activeName == "app") {
        this.tabsValue = 8;
      } else if (this.activeName == "marketing") {
        this.tabsValue = 7;
      }
    },
    // 商品列表
    getGoodsList() {
      let _this = this;
      _this.searchCom.loading = true;
      _this.axios
        .get(resolveWeiShopApi("/api/weishop/admin/goods/list"), {
          params: isRegionScope() ? appendCurrentRegionStore({
            ..._this.searchCom.post,
          }) : {
            ..._this.searchCom.post,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            _this.searchCom.table = res.data.data.map((item) => {
              return {
                ...item,
                id: item.goods_id,
				select:false
              };
            });
            _this.searchCom.total = res.data.total;
          } else {
            eltips(res.msg, "error");
          }
          _this.searchCom.loading = false;
        });
    },
    // 商品获取到的数据
    tableSelectionChange(e) {
      console.log("我是商品", e);
      this.curItem = {
        id: "commidy",
        path: e.goods_id,
        title: "商品详情-" + e.goods_name,
      };
    },
    // 自定义页面获取的数据
    tableSelectionChangeself(e) {
	  if(e.page_type==30){
		  this.curItem = {
		    id: "self",
		    path: 'pages/index/me?pageId='+e.page_id,
		    title: "个人中心-" + e.page_name,
		  };
	  } if(e.page_type==10){
		  this.curItem = {
		    id: "self",
		    path: 'pages/index/index?pageId='+e.page_id,
		    title: "首页-" + e.page_name,
		  };
	  }else{
		this.curItem = {
		  id: "self",
		  path: 'pages/index/diy?pageId='+e.page_id,
		  title: "自定义-" + e.page_name,
		};
	  }
     
    },
    // 商品分页
    changePageCom(e) {
      this.searchCom.post.page = e;
      this.getGoodsList();
    },
    // 分页
    changePage(e) {
      this.search.post.page = e;
      this.getSelfList();
    },
    // 获取自定义页面列表
    getSelfList() {
      let _this = this;
      _this.search.loading = true;
      _this.axios
        .get(resolveWeiShopApi("/api/weishop/admin/store/page/list"), {
          params: isRegionScope() ? appendCurrentRegionStore({
            ..._this.search.post,
          }) : {
            ..._this.search.post,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            _this.search.table = res.data.data;
            _this.search.total = res.data.total;
          } else {
            eltips(res.msg, "error");
          }
          _this.search.loading = false;
        });
    },
    handleSubmit(e) {
      if (this.activeName == "other") {
        this.curItem = {
          id: "other" + this.ruleForm.id,
          path:
            this.ruleForm.id == "1"
              ? this.ruleForm.path + "?" + this.ruleForm.queryStr
              : this.ruleForm.id == "2"
              ? this.ruleForm.AppID + +"&" + this.ruleForm.wpath
              : this.ruleForm.url,
          title:
            this.ruleForm.id == "1"
              ? "其他页面"
              : this.ruleForm.id == "2"
              ? "微信小程序"
              : "h5",
        };
      }
      this.$emit("handleSubmit", this.curItem);
      // 关闭对话框
      this.handleCancel();
    },
    handleCancel() {
      this.visibleDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  height: 476px;
  overflow: auto;
}
// 店铺
.shop_box {
  .shop_item {
    margin-bottom: 20px;
    cursor: pointer;
    .tit_box {
      font-weight: 600;
    }
    .box {
      display: flex;
      flex-wrap: wrap;
    }
    .item {
      margin: 10px 10px 0 0;
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      padding: 5px 9px;
	  font-size:12px
    }
    .item_active {
      border: 1px solid #006aff;
      color: #006aff;
    }
  }
}
// 商品
.goods_item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  .name {
    margin-left: 5px;
    text-align: left;
  }
}
// 修改对话框的padding
/deep/.el-dialog__body {
  padding: 10px 20px !important;
}
::v-deep .el-tabs__header {
  border-bottom: 1px solid #f5f5f5 !important;
  display: flex;
  justify-content: flex-start;
}
::v-deep .el-tabs__active-bar {
  height: 2px;
}
::v-deep .el-tabs__nav-wrap::after {
  content: "";
  height: 0;
  background-color: none;
}
::v-deep .el-table td {
  padding: 5px 0 !important;
}

.shang{
	&_head{
		display: flex;
	}
	&_tab{
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ededed;
		&_item{
			font-size: 14px;
			position: relative;
			margin: 0 20px;
			height: 40px;
			line-height: 40px;
			cursor: pointer;
		}
		&_active{
			&::after{
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				height: 2px ;
				width: 100%;
				background-color: #006aff;
			}
			
		}
	}
	&_box{
		&_item{
			display:inline-flex;
			border-radius: 5px;
			border: 1px solid #ededed;
			padding: 10px;
			width: calc(33.33% - 10px);
			margin: 10px 5px;
			cursor: pointer;
			position: relative;
		}
		&_active{
			border: 1px solid #006aff;
			
		}
		&_radio{
			position: absolute;
			right: -4px;
			bottom: -4px;
			color: #006aff;
		}
		&_img{
			width: 60px;
			height: 60px;
			display: block;
			margin-right: 10px;
			border-radius: 5px;
		}
		&_flex{
			flex: 1;
			overflow: hidden;
			white-space: nowrap;//禁止换行
			text-overflow: ellipsis;//当对象内文本溢出时显示省略标记
		}
		&_title{
			font-size: 16px;
			margin-bottom: 10px;
			overflow: hidden;
			white-space: nowrap;//禁止换行
			text-overflow: ellipsis;//当对象内文本溢出时显示省略标记
		}
		&_price{
			color: #006aff;
		}
		&_data{
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1;
		}
		&_num{
			color: #999;
		}
	}
}
</style>
